<!-- TABS -->
<eif-custom-tabs
	[tabs]="tabs"
	[activeTabId]="activeTabId"
	[actions]="tabActions"
	(tabChange)="onTabChange($event)"
	[class]="'mt-3 mb-4'">
	<div class="dashboard-tab-content">
		<!-- CONFIRMING AREA -->
		@if (loggedUser?.canSeeConfirmingOptions()) {
			@if (activeTabId === DASHBOARD_TAB_CONFIRMING) {
				<div>
					<!-- CURRENCIES -->
					@if (orderedCurrencies.length > 1) {
						<eif-custom-segmented-control
							[options]="currencyOptions"
							[value]="selectedCurrency"
							[class]="'mb-2'"
							[size]="'small'"
							[variant]="'outlined'"
							(valueChange)="clickedCurrency($event.toString())">
						</eif-custom-segmented-control>
					}
					<div class="dashboard-cards-wrap">
						<app-dashboard-metric-card
							card="confirming.contractedAmount"
							[value]="contractedAmount | currencyLocale: selectedCurrency"
							[loading]="loadingContractedAmount" />
						<app-dashboard-metric-card
							card="confirming.contractsAvailableAmount"
							[value]="contractsAvailableAmount | currencyLocale: selectedCurrency"
							[sublabel]="((contractsAvailableAmountRatio | numberLocale: '1.2-2') ?? '0') + '%'"
							[loading]="loadingContractsAvailableAmount" />
						<app-dashboard-metric-card
							card="confirming.notPaidDocuments"
							[value]="notPaidDocuments | currencyLocale: selectedCurrency"
							[loading]="loadingNotPaidDocuments" />
						<app-dashboard-metric-card
							card="confirming.approvedRequestFunds"
							[value]="approvedRequestFunds | currencyLocale: selectedCurrency"
							[labelSuffix]="CurrentMonth?.toString()"
							[loading]="loadingApprovedRequestFunds" />
						<app-dashboard-metric-card
							card="confirming.currentFundingRequestsAmount"
							[value]="currentFundingRequestsAmount | currencyLocale: selectedCurrency"
							[loading]="loadingCurrentFundingRequestsAmount" />
						<app-dashboard-metric-card
							card="confirming.monthlyAutomaticPayments"
							[value]="monthlyAutomaticPayments | currencyLocale: selectedCurrency"
							[labelSuffix]="CurrentMonth?.toString()"
							[loading]="loadingMonthlyAutomaticPayments" />
						<app-dashboard-metric-card
							card="confirming.buyersCompaniesCount"
							[value]="buyersWithActiveContractsCompaniesCount"
							[loading]="loadingBuyersWithActiveContractsCompaniesCount" />
						<app-dashboard-metric-card
							card="confirming.suppliersCompaniesCount"
							[value]="suppliersWithActiveConnectionsCompaniesCount"
							[loading]="loadingSuppliersWithActiveConnectionsCompaniesCount" />
						<app-dashboard-metric-card
							card="confirming.suppliersActiveConnections"
							[value]="suppliersActiveConnections"
							[loading]="loadingSuppliersActiveConnections" />
						<app-dashboard-metric-card
							card="confirming.pendingApprovalDocumentsAmount"
							[value]="confirmingPendingApprovalDocumentsAmount"
							[loading]="loadingConfirmingPendingApprovalDocumentsAmount"
							[hasAction]="!loggedUser?.IsFinancier"
							(action)="navigateToFilesIntegration(FileStatus.PendingBuyerApproval)" />
					</div>
				</div>
			}
		}

		<!-- FACTORING AREA -->
		@if (loggedUser?.canSeeFactoringOptions()) {
			@if (activeTabId === DASHBOARD_TAB_FACTORING) {
				<div>
					<app-dashboard-factoring-tab
						[currentMonth]="CurrentMonth"
						[canNavigate]="!loggedUser?.IsFinancier" />
				</div>
			}
		}
	</div>
</eif-custom-tabs>
